export default "__VITE_ASSET__961006f3__"